import React from "react"
import { Link } from "gatsby"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
export default function Card({
  slug,
  image,
  name,
  lowPrice,
  highPrice,
  capacity,
}) {
  return (
    <Link
      to={slug}
      className="grid gap-2 bg-white shadow-sm hover:shadow-xl transition duration-300 ease-in-out ring-1 ring-gray-200 "
    >
      {image && (
        <GatsbyImage
          image={image.asset && image.asset.gatsbyImageData}
          // alt={data.name}
          alt={name}
          className="w-full object-cover h-56 md:h-64"
        />
      )}
      <div className="p-2 flex justify-between h-auto md:h-20 items-center">
        <h3 className="font-semibold font-property text-[20px]">{name}</h3>
        <div className="flex space-x-3">
          {lowPrice && (
            <div className="grid">
              {/* <h4 className="text-[24px] font-semibold">{"€" + lowPrice}</h4> */}
              {lowPrice === "Price on request" ? (
                <h4 className="text-[11px] font-semibold">{lowPrice}</h4>
              ) : (
                <h4 className="text-[24px] font-semibold">{"€" + lowPrice}</h4>
              )}
              <p className="font-property text-[14px]">low season</p>
            </div>
          )}
          {highPrice && (
            <div className="grid">
              {/* <h4 className="text-[24px] font-semibold">{"€" + highPrice}</h4> */}
              {highPrice === "Price on request" ? (
                <h4 className="text-[11px] font-semibold">{highPrice}</h4>
              ) : (
                <h4 className="text-[24px] font-semibold">{"€" + highPrice}</h4>
              )}
              <p className="font-property text-[14px]">high season</p>
            </div>
          )}
          {capacity && (
            <div className="bg-gray-100 py-2 px-4 rounded-full text-xs flex space-x-3 items-center">
              <StaticImage
                placeholder="tracedSVG"
                src="../../../static/img/multiple-users-silhouette 1.svg"
                width={15}
                alt="capacity"
              />
              <span>{capacity}</span>
            </div>
          )}
        </div>
      </div>
    </Link>
  )
}
